import React from 'react';
import { useSelector } from 'react-redux';
import { IHeroBannerItem } from './utils';
import { isEditMode } from 'services/admin';
import { DynamicTranslationType, useEndUserInlineTextEditorTranslation, useEndUserTranslation } from 'hooks/use-translation';
import { getPageId } from 'services/app';

interface IUseHeroBannerLocalizeStringsResponse {
  description: string;
  primaryCtaText: string;
  secondaryCtaText: string;
  title: string;
}

const useHeroBannerLocalizeStrings = (heroBannerItem: IHeroBannerItem): IUseHeroBannerLocalizeStringsResponse => {
  const isEditing = useSelector(isEditMode);
  const pageId = useSelector(getPageId);
  const { inlineTextEditorEndUserT } = useEndUserInlineTextEditorTranslation(isEditing);
  const { endUserT } = useEndUserTranslation();

  const result = React.useMemo(() => {
    if (isEditing) {
      return {
        title: heroBannerItem.data.title.rawData,
        description: heroBannerItem.data.description.rawData,
        primaryCtaText: heroBannerItem.data.primaryCta.text,
        secondaryCtaText: heroBannerItem.data.secondaryCta.text,
      };
    }

    const baseParams = {
      blockId: heroBannerItem.arrayId,
      pageId,
    };

    return {
      title: inlineTextEditorEndUserT(DynamicTranslationType.heroBannerTitle, heroBannerItem.data.title.rawData, baseParams),
      description: inlineTextEditorEndUserT(DynamicTranslationType.heroBannerDescription, heroBannerItem.data.description.rawData, baseParams),
      secondaryCtaText: endUserT([DynamicTranslationType.heroBannerSecondaryCta, baseParams]) || heroBannerItem.data.secondaryCta.text,
      primaryCtaText: endUserT([DynamicTranslationType.heroBannerPrimaryCta, baseParams]) || heroBannerItem.data.primaryCta.text,
    };
  }, [heroBannerItem, isEditing, pageId, endUserT]);

  return result;
};

export default useHeroBannerLocalizeStrings;
